<template>
  <div class="d-flex flex-column justify-content-between vh-100 w-100">
    <main-hero heroTitle="Forgotten Password" />
    <div class="row">
      <div class="col">
        <b-row>
          <b-col class="col-12">
            <b-card class="bg-white overflow-hidden col-lg-6">
              <validation-observer ref="validation">
                <form @submit.prevent="onSubmit">
                  <validation-provider v-slot="{validated, errors, dirty, valid, invalid}" rules="required|email">
                    <b-form-group
                      id="fieldset-1"
                      :label="$t('Enter your email')"
                      label-for="forgotten-email"
                    >
                      <b-form-input id="forgotten-email" v-model="email" :state="(dirty || validated) ? (valid ? null : false) : null" trim />
                      <b-form-invalid-feedback :state="invalid" :force-show="invalid">
                        {{ errors[0] }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </validation-provider>
                  <div class="text-center d-flex flex-column">
                    <b-button variant="primary" size="sm" class="m-auto" type="submit">
                      {{ $t('Resend my password') }}
                    </b-button>
                  </div>
                  <router-link :to="{name: 'log-in', params:{email:loginEmail}}" class="text-link text-reset text-center d-block mt-3">
                    {{ $t('Back to login') }}
                  </router-link>
                </form>
              </validation-observer>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
    <app-footer />
  </div>
</template>

<script>
import store from '@/store'
import MainHero from "@/components/section/MainHero"
import AppFooter from "@/components/footer/AppFooter"
import Notification from '@/imports/mixins/notification';
import {ValidationProvider, ValidationObserver} from 'vee-validate';

export default {
  name: "ForgotPassword",
  components: {ValidationProvider, ValidationObserver, MainHero, AppFooter},
  mixins: [Notification],
  data() {
    return {
      email: this.$route.params.email ?? null,
      resentEmail: null,
    }
  },
  computed: {
    loginEmail() {
      return this.email !== null ? this.email : this.resentEmail;
    }
  },
  methods: {
    onSubmit() {
      this.$refs.validation.validate().then((success) => {
        if (!success) {
          return;
        }

        this.$api.auth.sendPasswordResetEmail(this.email)
          .finally(() => {
            this.resentEmail = this.email;
            this.email = null;
            this.$refs.validation.reset();
            this.notify(this.$bvToast, this.$t('A password reset email has been sent'), null, 'success');
          });
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.USER_STATE === true) {
      next({name:'dashboard'});
    } else {
      next();
    }
  },
}
</script>

<style scoped lang="scss">
  .card {
    box-shadow: 0 0 1.875rem rgba(0,0,0,.16);
    max-width: 576px;
    margin: -85px auto 0;
    border-radius: 48px;

    @include media-breakpoint-down(sm) {
      padding: 100px 25px 100px;
    }

    @include media-breakpoint-up(sm) {
      padding: 100px 60px 100px;
    }
  }
</style>
